import React, { useEffect, useState, useMemo } from 'react';

import { is3dTypeUtils } from '../../../../../utils/fileTypes/is3dTypeUtils';
import icone3D from '../../../../../assets/icone3d.png';
import { isJpnAndPngUtils } from '../../../../../utils/fileTypes/isJpgAndPngUtils';
import { isVideoTypeUtils } from '../../../../../utils/fileTypes/isVideoTypeUtils';
import { FaPlayCircle } from 'react-icons/fa';

import styles from './styles.module.css';

export const ImageComponent = React.memo(function ImageComponent({
    theSelectImage,
    imageParams,
    oViewer,
    handleImageSelect,
    image,
    handleChanceTheSelectedImage,
    checkedSwitchDesenho,
    addedMultipleImages,
}: any) {
    const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });
    const [isLoading, setIsLoading] = useState(true);
    const [showVideo, setShowVideo] = useState(false);

    useEffect(() => {
        if (isVideoTypeUtils(image.link)) {
            setIsLoading(false);
            return;
        }
        const imgElement = new window.Image();
        imgElement.src = image.link;
        imgElement.onload = () => {
            const width = imgElement.width;
            const height = imgElement.height;
            setImageDimensions({ width, height });
            setIsLoading(false);
        };
    }, [image.link]);

    const handleOnClickImage = (imageLink) => {
        // Apenas selecionar o vídeo, sem modal
        if (checkedSwitchDesenho) {
            handleImageSelect(imageLink, checkedSwitchDesenho);
        } else {
            handleChanceTheSelectedImage(imageLink);
            if (!isVideoTypeUtils(imageLink)) {
            oViewer.abrir(imageLink);
            }
        }
    };

    const is3DFile = (complemento) => is3dTypeUtils(complemento);

    const imgSrc = is3DFile(image.complemento)
        ? icone3D
        : isJpnAndPngUtils(image.complemento)
            ? `${image.link}?tw=259&th=229`
            : image.icone;

    const imgStyles = useMemo(() => {
        return {
            width: imageDimensions.width > imageDimensions.height ? '288px' : '138px',
            height: '146px',
            border: '1px solid #353535',
            objectFit: 'cover' as React.CSSProperties['objectFit'],
        };
    }, [imageDimensions]);

    return (
        <div
            className={`${styles.containerImage} ${(checkedSwitchDesenho && addedMultipleImages.includes(image.link)) ||
                (!checkedSwitchDesenho && (theSelectImage === image.link || (theSelectImage === '' && imageParams === image.link)))
                ? styles.containerImage_active
                : ''
                }`}
            title={image.nome}
            onClick={() => handleOnClickImage(image.link)}
        >
            {isLoading && !isVideoTypeUtils(image.link) && (
                <div className={styles.loader}>
                    <div />
                    <div />
                    <div />
                    <div />
                </div>
            )}
            {isVideoTypeUtils(image.link) ? (
                <div style={{ position: 'relative', width: '100%', height: '146px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#222' }}>
                    <FaPlayCircle size={48} color="#fff" style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', zIndex: 2 }} />
                    <video
                        src={image.link}
                        style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.5 }}
                        preload="metadata"
                        poster={image.poster || ''}
                        tabIndex={-1}
                        muted
                        onLoadedData={() => setIsLoading(false)}
                    />
                </div>
            ) : (
            <img
                src={imgSrc}
                onLoad={() => setIsLoading(false)}
                style={imgStyles}
                className={styles.img}
            />
            )}
            <div className={styles.linearGradient}>
                <span>{image.nome}</span>
            </div>
        </div>
    );
});
